export enum AccountType {
  ADMIN = 'admin',
  FREELANCER = 'freelancer',
  BRAND = 'brand',
  STORE = 'store',
  MANAGER = 'manager',
  POTENTIAL = 'potential'
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/users/account-type.ts